import { Routes } from '@angular/router';
import { authGuard, passwordChangeGuard, roleGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home').then((m) => m.Home),
  },
  {
    path: 'register',
    loadComponent: () => import('./debutants/register/register').then((m) => m.Register),
  },
  {
    path: 'datenschutz',
    loadComponent: () => import('./privacy/privacy').then((m) => m.Privacy),
  },
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login').then((m) => m.Login),
  },
  {
    path: 'change-password',
    canActivate: [authGuard],
    loadComponent: () => import('./auth/change-password/change-password').then((m) => m.ChangePassword),
  },
  {
    path: 'me',
    canActivate: [authGuard, roleGuard('debutant'), passwordChangeGuard],
    loadChildren: () => import('./debutants/debutants.routes').then((m) => m.debutantRoutes),
  },
  {
    path: 'admin',
    canActivate: [authGuard, roleGuard('admin'), passwordChangeGuard],
    loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found').then((m) => m.NotFound),
  },
];
